import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatCard, MatCardAppearance } from '@angular/material/card';
import { LegacyModeService } from '@boldpenguin/emperor-services';

export enum EmperorCardTypes {
  Outlined = 'outlined',
  Elevated = 'elevated',
}

@Component({
  selector: 'emperor-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmperorCardComponent extends MatCard implements OnChanges {
  @Input() type = EmperorCardTypes.Elevated;
  @Input() useMaterialBackgroundColor = false;
  override appearance: MatCardAppearance = 'raised';
  legacyService = inject(LegacyModeService, { optional: true });
  private cdr = inject(ChangeDetectorRef);

  @HostBinding('class')
  get hostClass(): string | null {
    if (!this.legacyService?.getLegacyMode()) {
      if (this.useMaterialBackgroundColor) {
        return null;
      }
      return 'emperor-ui-m3-card';
    }

    const classes = ['emperor-ui-card'];

    if (this.type === EmperorCardTypes.Elevated) {
      classes.push('emperor-ui-card-elevated');
    } else if (this.type === EmperorCardTypes.Outlined) {
      classes.push('emperor-ui-card-outlined');
    }

    return classes.join(' ');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.type) {
      if (this.type === EmperorCardTypes.Elevated) {
        this.appearance = 'raised';
      } else {
        this.appearance = 'outlined';
      }
      this.cdr.detectChanges();
    }
  }
}
